// removed by extract-text-webpack-plugin
module.exports = {"root":"mobile-app-prompt__root","header":"mobile-app-prompt__header","watchASLogo":"mobile-app-prompt__watchASLogo","closeButton":"mobile-app-prompt__closeButton","closeIcon":"mobile-app-prompt__closeIcon","content":"mobile-app-prompt__content","message":"mobile-app-prompt__message","footer":"mobile-app-prompt__footer","responseButton":"mobile-app-prompt__responseButton","background":"mobile-app-prompt__background"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/mobile-app-prompt/styles.less
// module id = 166
// module chunks = 1 2